// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Keyboard } from "@capacitor/keyboard";
import { isDefined } from "@clipboard-health/util-ts";

import { isCapacitorPlatform } from "./platformUtils";

export async function hideKeyboard() {
  const activeElement = document.activeElement as HTMLElement;

  if (isDefined(activeElement)) {
    activeElement.blur?.();
  }

  if (isCapacitorPlatform()) {
    // eslint-disable-next-line promise/prefer-await-to-then
    Keyboard.hide().catch(() => {
      // Ignore errors
    });
  }
}
